import {useEffect} from "react";
import {Button, Container, Row} from "../components/common";
import {CBAction, CBBody, CBHeader, CBTextBox, ContentBox} from "../components/common/ContentBox";
import {enrollQuestion, listQuestions, resetFactor} from "../services/api/factorApi";
import QuestionIcon from "../../images/icon_question.png";
import {equalsIgnoreCase} from "../utils/strings";
import {runApi} from "../services/api/ApiContext";
import {toast} from "react-toastify";
import {useState} from "react";
import {useFactors} from "../contexts/FactorsContext";
import {Redirect} from "react-router-dom";

const showFactor = [
    {type: 'question', provider: 'OKTA', name: 'question', order: 1},
]

const patchFactor = (factor) => {

    for (const showFactorElement of showFactor) {
        if (equalsIgnoreCase(factor.type, showFactorElement.type)
            && equalsIgnoreCase(factor.provider, showFactorElement.provider)) {
            factor = {
                name: showFactorElement.name,
                order: showFactorElement.order,
                ...factor,
            };
            return factor;
        }
    }

    return null;
}

const MFASetupQuestionView = () => {
    const [questions, setQuestions] = useState(null);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [userPastQuestionText, setUserPastQuestionText] = useState(null);
    const [userPastQuestion, setUserPastQuestion] = useState(null);
    const [factorId, setFactorId] = useState(null);
    const [loadingQuestion, setLoadingQuestion] = useState(true);
    const {data, refresh} = useFactors();
    const factors = data?.factors?.map(patchFactor).filter((f) => !!f);
    const securityQuestionExists = data?.factors ? data?.factors.filter(x => x.type === "question").length > 0 : false;

    useEffect(() => {
        async function listFromApi() {
            const listQuestionsResponse = await runApi(
                'listQuestion',
                () => listQuestions()
            );

            if (listQuestionsResponse?.data?.data) {
                const questions = listQuestionsResponse.data.data.logs;
                setQuestions(questions);
            }
        }

        listFromApi();
    }, []);

    useEffect(() => {

        if (factors && factors.length > 0) {
            if (factorId !== factors[0]?.id) {
                setLoadingQuestion(false);
                setUserPastQuestionText(factors[0]?.profile?.questionText);
                setUserPastQuestion(factors[0]?.profile?.question);
                setSelectedQuestion(factors[0]?.profile?.question);
                setFactorId(factors[0]?.id);
            }
        }

    }, [factors, factorId]);

    useEffect(() => {
        if (data) {
            setLoadingQuestion(false);
        }
    }, [data, setLoadingQuestion]);

    const editEvent = () => {
        setEditMode(true);
    }

    const cancelEditMode = () => {
        setEditMode(false);
    }

    /*async function onSubmit(e) {
        const editQuestionResponse = await runApi(
            'updateQuestion',
            () => updateQuestion(factorId, selectedQuestion, answer)
        );

        if (!editQuestionResponse?.data?.status) {
            return;
        }

        toast.success("Update success");
    }*/

    const onReset = async () => {
        const resetFactorResponse = await runApi(
            'resetFactor',
            () => resetFactor(factorId)
        );

        if (!resetFactorResponse?.data?.data) {
            return;
        }

        toast.success("Reset factor successfully");
        setLoadingQuestion(true);
        await refresh();
        setAnswer(null);
        setEditMode(false);
    }

    const onEnroll = async () => {
        let questionToPass = selectedQuestion;

        if (!questionToPass) {
            if (questions && questions.length > 0) {
                questionToPass = questions[0].question;
            }
        }

        const enrollQuestionResponse = await runApi(
            'enrollQuestion',
            () => enrollQuestion(questionToPass, answer)
        );

        if (!enrollQuestionResponse?.data?.data) {
            return;
        }

        toast.success("Enroll factor successfully");
        setLoadingQuestion(true);
        await refresh();
        setAnswer(null);
        setEditMode(false);
    }

    const onClear = (event) => {
        setSelectedQuestion(userPastQuestion);
        setAnswer(null);
        cancelEditMode();
    }

    return (
        !securityQuestionExists ? (<Redirect to={'/'}/>) :
            (<Container>
                <h1>Setup Security Questions</h1>

                <Row>
                    <div className="col-12 col-lg-7">
                        <ContentBox>
                            <CBHeader icon={QuestionIcon} title={'FORGOTTEN PASSWORD QUESTION'} showEdit={!editMode}
                                      editEvent={() => editEvent()}/>
                            <CBBody>
                                <p className="red">Select a forgotten password question so you can reset your password
                                    in
                                    case you have trouble signing in to your Okta account.</p>
                                <p>Tips for choosing a good security question:</p>
                                <ul>
                                    <li>Don’t pick a question that someone could easily guess or find out the answer to
                                        by
                                        looking at your resume or social networking profile.
                                    </li>
                                    <li>Pick a question with an answer that is easy for you to remember.</li>
                                    <li>Don’t write your security question down on a piece of paper where someone could
                                        find
                                        it.
                                    </li>
                                </ul>

                                {!loadingQuestion && <div className="question-form">
                                    <div className="row">
                                        <div className="col-12">
                                            {!editMode && userPastQuestionText &&
                                            <CBTextBox name={'Enrolled Question'} value={userPastQuestionText}
                                                       disabled={!editMode}/>}
                                            {!editMode && !userPastQuestionText &&
                                            <p><strong>You have not setup the security question.</strong></p>}
                                            {editMode && <label>Question</label>}

                                            {editMode &&
                                            <select disabled={!!userPastQuestionText} value={selectedQuestion}
                                                    onChange={e => setSelectedQuestion(e.target.value)}>{questions ? questions.map(function (val, idx) {
                                                return <option value={val.question}>{val.questionText}</option>;
                                            }) : []}
                                            </select>}
                                        </div>
                                        {editMode &&
                                        <div className="col-12">
                                            {!userPastQuestionText && <CBTextBox name={'Answer'}
                                                                                 value={editMode ? answer : "Mankind was born on Earth."}
                                                                                 onChange={(event) => setAnswer(event.target.value)}
                                            />}
                                        </div>}
                                    </div>
                                    {editMode &&
                                    <CBAction>
                                        {!userPastQuestionText &&
                                        <Button type={'submit'} onClick={(event) => onEnroll(event)}>Save</Button>}
                                        {userPastQuestionText &&
                                        <Button type={'submit'} onClick={(event) => onReset(event)}>Delete</Button>}
                                        <Button onClick={(event) => onClear(event)}>Cancel</Button>
                                    </CBAction>
                                    }

                                </div>}

                                {loadingQuestion && 'Loading...'}
                            </CBBody>
                        </ContentBox>
                    </div>
                </Row>
            </Container>)
    );
}

export default MFASetupQuestionView;
